import { PostTask } from "@/services/fhir/task/PostTask";
import type { ITaskData } from "@/utils/interfaces";

/** Mesmo `system` usado em `QuestionnaireRespondPage` (notificação ao profissional). */
export const QUESTIONNAIRE_ANSWERED_NOTIFICATION_TASK_CODE_SYSTEM =
  "https://fluxmed.com.br/fhir/CodeSystem/task-types";

export const QUESTIONNAIRE_ANSWERED_NOTIFICATION_TASK_CODE =
  "QUESTIONNAIRE_ANSWERED_NOTIFICATION";

export interface PostQuestionnaireAnsweredNotificationTaskInput {
  patientDisplayName: string;
  questionnaireTitle: string;
  questionnaireId: string;
  /** Referência FHIR do paciente (ex.: `Patient/...`) — vai em `requester` da Task de notificação. */
  subjectReference: string;
  /** Profissional que recebe a notificação (`for`). */
  requesterPractitionerRoleReference: string;
  /** Organização dona da task (`owner`), ex.: `Organization/...`. */
  ownerOrganizationReference: string;
}

/**
 * Cria a Task de notificação “questionário respondido”, alinhada ao fluxo
 * `/questionnaire-respond` com `location.state` completo.
 */
export async function postQuestionnaireAnsweredNotificationTask(
  input: PostQuestionnaireAnsweredNotificationTaskInput,
): Promise<void> {
  const description = `Paciente ${input.patientDisplayName} respondeu ao questionário ${input.questionnaireTitle || input.questionnaireId}`;

  const taskData: ITaskData = {
    status: "requested",
    intent: "order",
    priority: "routine",
    owner: input.ownerOrganizationReference,
    for: input.requesterPractitionerRoleReference,
    requester: input.subjectReference,
    description,
    code: {
      text: "Questionário respondido",
      coding: [
        {
          system: QUESTIONNAIRE_ANSWERED_NOTIFICATION_TASK_CODE_SYSTEM,
          code: QUESTIONNAIRE_ANSWERED_NOTIFICATION_TASK_CODE,
        },
      ],
    },
  };

  await PostTask(taskData);
}
